export default __webpack_public_path__ + "static/media/banner1.702d29af.png";